// Header/index.js
import Header from './Header';
export default Header;
